import { Component, Input } from '@angular/core';
import { HighlightDirective } from '../utils/highlight.directive';

@Component({
  standalone: true,
  imports: [HighlightDirective],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[ucx-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '[class.small]': 'size ===  "small"',
  },
})
export class ButtonComponent {
  @Input()
  size = '';
}
